module.exports = "../content/b2d307df606f23cb14e6483039e2b7fa.ttf";